import { useInView } from '@/hooks/useInView';

const packages = [
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/Frame-81.jpg', title: '10 KITS', price: '$3,500', discount: '7% DISCOUNT', points: ['10 kits of educational robot', '30 educational cartoons', 'Training for teachers – 10 lessons', 'Warranty repair and service – 1 year', 'Educational materials'], featured: false },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/Frame-83.jpg', title: '30 KITS', price: '$9,250', discount: '12% DISCOUNT', points: ['30 kits of educational robot', '30 educational cartoons', 'Training for teachers – 10 lessons', 'Warranty repair and service – 1 year', 'Educational materials'], featured: true },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/Frame-82.jpg', title: '20 KITS', price: '$6,500', discount: '7% DISCOUNT', points: ['20 kits of educational robot', '30 educational cartoons', 'Training for teachers – 10 lessons', 'Warranty repair and service – 1 year', 'Educational materials'], featured: false },
];

export default function OffersSection() {
  const { ref, inView } = useInView();

  return (
    <section id="offers" ref={ref as React.RefObject<HTMLElement>} className="bg-gray-900 py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className={`text-center mb-14 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-400 mb-3">Pricing</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white font-syne">Offers for Schools &amp; Institutions</h2>
          <p className="text-gray-400 mt-3 text-sm">Choose the package that fits your classroom size</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
          {packages.map((pkg, i) => (
            <div
              key={pkg.title}
              className={`rounded-2xl overflow-hidden flex flex-col transition-all duration-500 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${pkg.featured ? 'ring-2 ring-yellow-400 md:-mt-4 md:mb-4' : ''}`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-full h-44 relative">
                <img src={pkg.img} alt={pkg.title} className="w-full h-full object-cover object-top" />
                {pkg.featured && (
                  <div className="absolute top-3 right-3 bg-yellow-400 text-gray-900 text-xs font-bold px-3 py-1 rounded-full">Most Popular</div>
                )}
              </div>
              <div className={`p-6 flex flex-col flex-1 ${pkg.featured ? 'bg-yellow-400' : 'bg-white'}`}>
                <h3 className={`text-xl font-extrabold mb-1 font-syne ${pkg.featured ? 'text-gray-900' : 'text-gray-900'}`}>{pkg.title}</h3>
                <p className={`text-3xl font-extrabold mb-5 ${pkg.featured ? 'text-gray-900' : 'text-gray-900'}`}>{pkg.price}</p>
                <ul className="flex flex-col gap-2.5 flex-1 mb-6">
                  {pkg.points.map((p) => (
                    <li key={p} className={`flex items-start gap-2 text-sm ${pkg.featured ? 'text-gray-800' : 'text-gray-600'}`}>
                      <i className={`ri-check-line mt-0.5 flex-shrink-0 ${pkg.featured ? 'text-gray-900' : 'text-yellow-500'}`}></i>
                      {p}
                    </li>
                  ))}
                </ul>
                <div className={`text-xs font-bold mb-4 px-3 py-1.5 rounded-full inline-block w-fit ${pkg.featured ? 'bg-gray-900 text-yellow-400' : 'bg-yellow-100 text-yellow-700'}`}>
                  {pkg.discount}
                </div>
                <a
                  href="#contact"
                  onClick={(e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className={`block text-center font-bold py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm ${pkg.featured ? 'bg-gray-900 text-white hover:bg-gray-800' : 'bg-gray-900 text-white hover:bg-gray-800'}`}
                >
                  Select Package
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
